import { Identifier } from "../../core";
import { ModifierItemTypeId } from "./ModifierItemTypeId";
import { ExtraFeeId } from "./ExtraFeeId";
export class ModifierItemPackagingVariantId extends Identifier {
    constructor(modifierItemTypeId, packagingFeeId) {
        super("ModifierItemPackagingVariantId", packagingFeeId === null
            ? modifierItemTypeId.value
            : `${modifierItemTypeId.value}:${packagingFeeId.value}`);
    }
    static parse(value) {
        const colonIndex = value.indexOf(":");
        if (colonIndex === -1) {
            // Bare typeId — no packaging fee
            return new ModifierItemPackagingVariantId(new ModifierItemTypeId(value), null);
        }
        const typeIdStr = value.substring(0, colonIndex);
        const feeIdStr = value.substring(colonIndex + 1);
        return new ModifierItemPackagingVariantId(new ModifierItemTypeId(typeIdStr), feeIdStr === "null" ? null : new ExtraFeeId(feeIdStr));
    }
}
